<div class="main-padding">
  <h3 class="header-bottom header-text1">{{ 'CONTRACT_CANCEL.TITLE' | translate }}</h3>
  <div class="text-center">
    <div class="text-center finish">
      {{ 'CONTRACT_CANCEL.FINISH_CONTRACT_CANCELED' | translate }}
    </div>
    <div class="text-center">
      <div class="col-12">
        <div class="display finish2">
          <a (click)="back()" class="btn-grey">{{ 'CONTRACT_CANCEL.FINISH_BUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>     
</div>